<template>
  <SectionContainerPage>
    <SectionAssetStatusList
      xs12
      :assetStatusList="assetStatusList"
      :activityTypeList="activityTypeList"
      :shouldShowSearch="true"
      :toolbarActions="[
        {
          text: 'Equipment Status',
          icon: 'add',
          iconColor: 'success',
          emitEvent: 'onAddNewAssetStatusClicked',
        },
      ]"
      @onAddNewAssetStatusClicked="showDialogFormAssetStatusAdd = true"
      @onEditAssetStatusClicked="
        (val) => [
          (assetStatusToEdit = val.assetStatusToEdit),
          (showDialogFormAssetStatusEdit = true),
        ]
      "
      :isLoading="isLoading"
    />
    <DialogFormAssetStatusAdd
      :showDialog="showDialogFormAssetStatusAdd"
      @onCancelClicked="showDialogFormAssetStatusAdd = false"
      @onSubmitClicked="(val) => [onDialogFormAssetStatusAddSubmit(val)]"
      :isLoading="isLoading"
      :activityTypeList="activityTypeList"
    />
    <DialogFormAssetStatusEdit
      :showDialog="showDialogFormAssetStatusEdit"
      :assetStatusToEdit="assetStatusToEdit"
      @onCancelClicked="showDialogFormAssetStatusEdit = false"
      @onSubmitClicked="(val) => [onDialogFormAssetStatusEditSubmit(val)]"
      :activityTypeList="activityTypeList"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionAssetStatusList from './sections/SectionAssetStatusList'
import DialogFormAssetStatusAdd from '../dialogs/DialogFormAssetStatusAdd'
import DialogFormAssetStatusEdit from '../dialogs/DialogFormAssetStatusEdit'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

export default {
  components: {
    SectionContainerPage,
    SectionAssetStatusList,
    DialogFormAssetStatusAdd,
    DialogFormAssetStatusEdit,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {},
  data: () => ({
    showDialogFormAssetStatusAdd: false,
    showDialogFormAssetStatusEdit: false,
    assetStatusList: [],
    activityTypeList: [],
    assetStatusToEdit: {},
    isLoadingCount: 0,
  }),
  activated() {
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
  },
  watch: {
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    onDialogFormAssetStatusAddSubmit(data) {
      this.isLoadingCount++
      this._insertAssetStatus({
        name: data.name,
        isIdle: data.isIdle,
        activityTypeIds: data.activityTypeIds,
        isUpcoming: data.isUpcoming,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormAssetStatusAdd = false
          this.fetchLists()
          this.$emit('notify', { message: 'Status successfully created!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onDialogFormAssetStatusEditSubmit(data) {
      this.isLoadingCount++
      this._updateAssetStatus({
        id: data.id,
        name: data.name,
        isIdle: data.isIdle,
        activityTypeIds: data.activityTypeIds,
        isUpcoming: data.isUpcoming,
        isEnabled: data.isEnabled,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormAssetStatusEdit = false
          this.fetchLists()
          this.$emit('notify', { message: 'Status successfully updated!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: ['Status', 'ActivityType'],
        successCb: (data) => {
          this.isLoadingCount--
          this.assetStatusList = data.statuses
          this.activityTypeList = data.activityTypes
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.assetStatusList = []
          this.activityTypeList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
